import { CHECKPOINT_STATUS_TO_PARAMS } from 'backups/modules/CheckpointModule/CheckpointModule';
import moment from 'moment';
import R from 'ramda';
import { CronExpHelper } from 'utils/CronExpHelper/CronExpHelper';

const WEEKDAYS_OPTIONS = [
    {
        key: 'all',
        value: 'all',
        text: 'Ежедневно',
    },
    {
        key: '1',
        value: '1',
        text: 'Пн',
    },
    {
        key: '2',
        value: '2',
        text: 'Вт',
    },
    {
        key: '3',
        value: '3',
        text: 'Ср',
    },
    {
        key: '4',
        value: '4',
        text: 'Чт',
    },
    {
        key: '5',
        value: '5',
        text: 'Пт',
    },
    {
        key: '6',
        value: '6',
        text: 'Сб',
    },
    {
        key: '0',
        value: '0',
        text: 'Вс',
    },
];

const convertToCronString = ({
    backupFrequency = '',
    weekdays = '*',
    minute = '',
    hour = '',
    date = '*',
    month = '*',
}) => {
    const hourlyRegexp = /each_([0-9]+)_hours/;
    const isHourly = backupFrequency.match(hourlyRegexp);

    if (isHourly) {
        return ['00', `*/${isHourly[1]}`, '* * *'].join(' ');
    }

    const utcMoment = moment()
        .hour(hour)
        .minute(minute)
        .weekday(1)
        .utc();
    const weekdayShift = utcMoment.weekday() - 1;
    hour = utcMoment.hour();
    minute = utcMoment.minute();

    if (Array.isArray(weekdays)) {
        weekdays = weekdays.map((day) => {
            let dayShifted = +day + weekdayShift;
            if (dayShifted > 7) {
                dayShifted = dayShifted - 7;
            } else if (dayShifted < 0) {
                dayShifted = dayShifted + 7;
            }
            return dayShifted;
        });
    }

    return [
        _prependZero(minute),
        _prependZero(hour),
        date,
        month,
        weekdays,
    ].join(' ');
};

const _prependZero = (d) => {
    if (d !== '*' && String(d).length === 1) {
        return `0${d}`;
    }
    return d;
};

const convertToCronObject = (cronString) => {
    let [minute, hour, , , weekdays] = cronString.split(' ');

    if (weekdays === '*') {
        weekdays = '0,1,2,3,4,5,6';
    }

    const getLocalMoment = (weekday) =>
        moment()
            .utc()
            .weekday(weekday)
            .hour(hour)
            .minute(minute)
            .local();

    weekdays = weekdays
        .split(',')
        .map((weekday) => String(getLocalMoment(weekday).weekday()));

    const localMoment = getLocalMoment(weekdays[0]);
    hour = localMoment.hour();
    minute = localMoment.minute();

    return {
        minute: _prependZero(minute),
        hour: _prependZero(hour),
        weekdays,
    };
};

const convertToScheduleObject = (cronString) => {
    return CronExpHelper.getHumanReadableTexts(cronString);
};

const formatCheckpointDate = (checkpoint) =>
    moment(checkpoint.timestamp * 1000).format('D MMMM YYYY, HH:mm');

const formatDatabaseCheckpointDate = (checkpoint) =>
    moment
        .utc(checkpoint.created)
        .local()
        .format('D MMMM YYYY, HH:mm');

const getCheckpointStatusParams = (checkpoint) =>
    CHECKPOINT_STATUS_TO_PARAMS[checkpoint.status];

const BACKUP_FREQUENCY_OPTIONS = [
    {
        value: 'each_3_hours',
        key: 'each_3_hours',
        text: 'Каждые 3 часа',
    },
    {
        value: 'each_12_hours',
        key: 'each_12_hours',
        text: 'Каждые 12 часов',
    },
    {
        value: 'daily',
        key: 'daily',
        text: 'Раз в сутки',
    },
];

const BACKUP_FREQUENCY_OPTIONS_WITH_NONE = [
    {
        value: 'none',
        key: 'none',
        text: 'Отключено',
    },
    ...BACKUP_FREQUENCY_OPTIONS,
];

const AUTOPLAN_MAX_BACKUPS = {
    each_3_hours: 56,
    each_12_hours: 14,
    daily: 7,
};
function getMaxBackups(backupFrequency) {
    return AUTOPLAN_MAX_BACKUPS[backupFrequency];
}

const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6].map(String);

function createIncrementalTrigger(fullTrigger) {
    return {
        ...fullTrigger,
        weekdays: R.difference(ALL_DAYS, fullTrigger.weekdays),
    };
}

const handleTriggersToFormValue = R.map(
    R.evolve({
        weekdays: R.pipe(
            R.sort(R.ascend(R.identity)),
            R.map(String),
            R.ifElse(R.equals(ALL_DAYS), () => ['all'], R.identity),
        ),
    }),
);

const handleFormTriggersValue = R.map(
    R.evolve({
        weekdays: (value) => (value.includes('all') ? ALL_DAYS : value),
    }),
);

export const BackupsUtils = {
    createIncrementalTrigger,
    convertToCronString,
    convertToCronObject,
    convertToScheduleObject,
    formatCheckpointDate,
    formatDatabaseCheckpointDate,
    getCheckpointStatusParams,
    BACKUP_FREQUENCY_OPTIONS,
    BACKUP_FREQUENCY_OPTIONS_WITH_NONE,
    WEEKDAYS_OPTIONS,
    getMaxBackups,
    handleTriggersToFormValue,
    handleFormTriggersValue,
};
